import type { BusinessSetupStatus } from "./api";

export type BusinessSetupConfirmation = "earning" | "redemption" | "complete" | null;
export type BusinessSetupWizardStage =
  | "earning_rule"
  | "earning_confirmation"
  | "redemption_rule"
  | "redemption_confirmation"
  | "quick_offer"
  | "complete";

export interface BusinessSetupWizardProgress {
  earning: boolean;
  redemption: boolean;
  quickOffer: boolean;
}

/**
 * Setup progress is intentionally normalized in sequence. A later backend flag can never make a
 * later step look complete while an earlier requirement is unfinished.
 */
export function businessSetupWizardProgress(
  setup: BusinessSetupStatus,
): BusinessSetupWizardProgress {
  const earning = setup.earningRuleReady;
  const redemption = earning && setup.redemptionRuleReady;
  const quickOffer = redemption && setup.quickOfferReady;
  return { earning, redemption, quickOffer };
}

export function businessSetupWizardStage(
  setup: BusinessSetupStatus,
  confirmation: BusinessSetupConfirmation = null,
): BusinessSetupWizardStage {
  if (confirmation === "earning") return "earning_confirmation";
  if (confirmation === "redemption") return "redemption_confirmation";
  if (confirmation === "complete") return "complete";

  const progress = businessSetupWizardProgress(setup);
  if (!progress.earning) return "earning_rule";
  if (!progress.redemption) return "redemption_rule";
  if (!progress.quickOffer) return "quick_offer";
  return "complete";
}
